import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconPendingCatalog: React.FC<IconProps> = ({
  size = 17,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M14.9805 1.01465C15.2673 1.0149 15.4997 1.24735 15.5 1.53418V3.35742H15.9805C16.2673 3.35768 16.4997 3.59011 16.5 3.87695V6.44238H16.9805C17.2672 6.44264 17.4996 6.67518 17.5 6.96191V11.585H18C18.8284 11.585 19.5 12.2565 19.5 13.085V17.5732C19.4999 18.4015 18.8283 19.0732 18 19.0732H2C1.17166 19.0732 0.500148 18.4015 0.5 17.5732V13.085C0.5 12.2565 1.17157 11.585 2 11.585H2.5V6.96191C2.50037 6.6752 2.73278 6.44264 3.01953 6.44238H3.5V3.87695C3.50025 3.59014 3.73272 3.35767 4.01953 3.35742H4.5V1.53418C4.50025 1.24736 4.73271 1.0149 5.01953 1.01465H14.9805ZM2 12.585C1.72386 12.585 1.5 12.8088 1.5 13.085V17.5732C1.50015 17.8493 1.72395 18.0732 2 18.0732H18C18.2761 18.0732 18.4999 17.8493 18.5 17.5732V13.085C18.5 12.8088 18.2761 12.585 18 12.585H13.3418L13.1914 12.9736C12.6795 14.2894 11.4119 15.1562 10 15.1562C8.58814 15.1562 7.3205 14.2894 6.80859 12.9736L6.6582 12.585H2ZM3.5 11.585H6.94141C7.15276 11.585 7.34479 11.6987 7.44824 11.8779L7.4873 11.958L7.74121 12.6104C8.10359 13.5418 9.00048 14.1562 10 14.1562C10.9995 14.1562 11.8964 13.5418 12.2588 12.6104L12.5127 11.958L12.5518 11.8779C12.6552 11.6987 12.8472 11.585 13.0586 11.585H16.5V7.44238H3.5V11.585ZM4.5 6.44238H15.5V4.35742H4.5V6.44238ZM5.5 3.35742H14.5V2.01465H5.5V3.35742Z"
      fill="currentColor"
    />
  </svg>
);

export default IconPendingCatalog;
